import { css, styled } from 'canoe';
import React from 'react';

import { TooltipCarousel } from './TooltipCarousel';

export const EmptyPattern = styled.div`
  ${({ theme }) => css`
    width: 100%;
    height: 100%;
    background: repeating-conic-gradient(
        ${theme.colors.GlitterGrayL30} 0% 25%,
        ${theme.colors.White} 0% 50%
      )
      50% / 60px 60px;
    border-radius: ${theme.borderRadius.small};
    position: relative;
    overflow: hidden;
  `}
`;

export const WhiteBg = styled.div`
  ${({ theme }) => css`
    width: 100%;
    height: 100%;
    background: #ffffff;
    border-radius: ${theme.borderRadius.small};
    position: relative;
    overflow: hidden;
  `}
`;

interface WrapperProps {
  children: React.ReactNode;
  checkeredBackdrop?: boolean;
  hotspotLimit?: number;
  currentTooltip?: number;
  setTooltip?: (index: number) => void;
  tooltipNodeIds?: string[];
}

export const ContentThumbnailWithCarousel = ({
  children,
  checkeredBackdrop,
  hotspotLimit,
  currentTooltip,
  setTooltip,
  tooltipNodeIds,
}: WrapperProps) => {
  const WrapperElement = checkeredBackdrop ? EmptyPattern : WhiteBg;

  return (
    <>
      <WrapperElement>{children}</WrapperElement>
      {tooltipNodeIds &&
        tooltipNodeIds.length > 1 &&
        typeof currentTooltip !== 'undefined' &&
        typeof setTooltip !== 'undefined' && (
          <TooltipCarousel
            size={!hotspotLimit ? 'normal' : 'l'}
            currentTooltip={currentTooltip}
            setTooltip={setTooltip}
            tooltips={tooltipNodeIds.filter(
              (nodeId, index) => !hotspotLimit || index + 1 <= hotspotLimit,
            )}
          />
        )}
    </>
  );
};
